export const wizardPostFormHiddenFields: string[] = ['affiliate', 'visitor_id', 'visitorId'];
